module.exports = {
  GOOGLE_MAP_KEY: "AIzaSyC9OtUmcUlFqfRPlKurd8ZYb6YCRinkrQo",

  HOST_KONG_TRAFFT: "https://kong.traffy.in.th/",
  HOST_API_FONDUE: "https://kong.traffy.in.th/non-auth",
  HOST_API_FONDUE_V1: "https://kong.traffy.in.th/fondue-auth",
  HOST_API_FONDUE_WRITE_V1: "https://kong.traffy.in.th/fondue-write/v1",
  HOST_API_CHAMP_FONDUE_V1: "https://champ.traffy.in.th/v1",

  HOST_REVERSE_GEO: "https://kong.traffy.in.th/fondue-reverse-geo",
  HOST_GOOGLE_MAP: "https://maps.googleapis.com/maps/api",

  HOST_POSTGREST: "https://api.traffy.in.th/postgrest",
};

